/**
 * Web ana sayfa tanıtımı: kullanıcı başına bir kez. "Geç" ya da "Başlayalım"
 * denince işaretlenir; hesap sayfasındaki "Tanıtımı Tekrar İzle" sıfırlar.
 */
export const tourKey = (userId) => `terakki_web_tour_v1_${userId}`;

const store = (storage) => storage || (typeof window !== "undefined" ? window.localStorage : null);

export function isTourSeen(userId, storage) {
  if (!userId) return true;
  try {
    return store(storage)?.getItem(tourKey(userId)) === "1";
  } catch {
    return true;
  }
}

export function markTourSeen(userId, storage) {
  if (!userId) return;
  try {
    store(storage)?.setItem(tourKey(userId), "1");
  } catch {
    // Saklanamazsa bir sonraki girişte yine gösterilir.
  }
}

export function resetTour(userId, storage) {
  if (!userId) return;
  try {
    store(storage)?.removeItem(tourKey(userId));
  } catch {
    // Yok say.
  }
}
